import React from 'react'
import { useNavigate } from 'react-router-dom'

import engine from '../../Assets/engine.png'

import './Shopnow.scss'

const Shopnow = () => {
  let Navigate = useNavigate()

  return (
    <div className='main_shop'>
      <div className="shop_title">
        Accessoiries
      </div>
      <img src={engine} />
      <button onClick={() => Navigate("/store")}>Shop Now</button>
    </div>
  )
}

export default Shopnow
